import React from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as PropTypes from 'prop-types';
import { getEXLogo, updateEXLogo } from '../../store/actions';

import UpdateExtensionLogo from "../../components/ExtensionConfiguration/UpdateExtensionLogo";
import ExtensionSettings from "../../components/ExtensionConfiguration/ExtensionSettings";
import NotificationConfiguration from "../../components/ExtensionConfiguration/NotificationConfiguration";
import HelpdeskIntegration from "../../components/ExtensionConfiguration/HelpdeskIntegration";

import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger
} from "../../components/ui/tabs";

const ExtensionConfiguration = ({
  currentEXLogo,
  dispatchGetEXLogo,
  dispatchUpdateEXLogo,
}) => {
  return (
    <div className="px-4 sm:px-6 mx-auto py-6">
      <h1 className="text-3xl font-bold mb-6">
        Extension Configuration
      </h1>

      <Tabs defaultValue="extension" className="mb-6">
        <TabsList className="mb-4 w-full sm:w-auto">
          <TabsTrigger value="extension" className="flex-1 sm:flex-none">
            Extension Settings
          </TabsTrigger>
          <TabsTrigger value="helpdesk" className="flex-1 sm:flex-none">
            Helpdesk Integration
          </TabsTrigger>
          <TabsTrigger value="notification" className="flex-1 sm:flex-none">
            Notification Configuration
          </TabsTrigger>
        </TabsList>

        <TabsContent value="extension">
          <UpdateExtensionLogo
            currentEXLogo={currentEXLogo}
            dispatchGetEXLogo={dispatchGetEXLogo}
            dispatchUpdateEXLogo={dispatchUpdateEXLogo}
          />

          <ExtensionSettings />
        </TabsContent>

        <TabsContent value="helpdesk">
          <HelpdeskIntegration />
        </TabsContent>

        <TabsContent value="notification">
          <NotificationConfiguration />
        </TabsContent>
      </Tabs>
    </div>
  );
};

ExtensionConfiguration.defaultProps = {
  currentEXLogo: null,
};

ExtensionConfiguration.propTypes = {
  dispatchGetEXLogo: PropTypes.func.isRequired,
  dispatchUpdateEXLogo: PropTypes.func.isRequired,
  currentEXLogo: PropTypes.string,
};

const mapStateToProps = (state) => {
  const { currentEXLogo } = state.EXConfig;
  return { currentEXLogo };
};

const mapDispatchToProps = {
  dispatchGetEXLogo: getEXLogo,
  dispatchUpdateEXLogo: updateEXLogo,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ExtensionConfiguration));